import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/mock";

export default function WhatsAppFloat() {
  const message = encodeURIComponent(
    "Hi BarknFurs! I'd like to book a grooming session for my pet."
  );
  const href = `https://wa.me/${BRAND.whatsapp}?text=${message}`;
  const handleClick = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", {
        event_category: "engagement",
        event_label: "whatsapp_float",
        method: "whatsapp",
      });
    }
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] pulse-ring" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white pl-4 pr-5 py-3.5 rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform group-hover:scale-105">
        <MessageCircle className="w-5 h-5 fill-white" strokeWidth={0} />
        <span className="hidden sm:inline font-semibold text-sm">Book on WhatsApp</span>
      </span>
    </a>
  );
}
